import { render } from "./ObstructingSection.vue?vue&type=template&id=5bd77d11"
import script from "./ObstructingSection.vue?vue&type=script&lang=js"
export * from "./ObstructingSection.vue?vue&type=script&lang=js"

import "./ObstructingSection.vue?vue&type=style&index=0&id=5bd77d11&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__